



























































































































































































import {DetailIncomingItemInfo} from "@/store/statistics/types";
import {dateFilter} from "@/utils/date-util";
import {Component, Prop, Vue} from "vue-property-decorator";
import {Action} from "vuex-class";
import {colorClassByStatus} from "@/utils/page-utils";
import {MsgTransports} from "@/store/types";
import {InputWings, TextareaWings} from "wings-ui-components";

@Component({
  components: {InputWings, TextareaWings},
  filters: { dateFilter },
  methods: {colorClassByStatus}
})
export default class DetailIncomingInfo extends Vue {
  @Prop() transport!: MsgTransports;
  @Action("getStatisticDetailIncomingInfo") actionGetItem: any;

  messageInfo: DetailIncomingItemInfo = new DetailIncomingItemInfo();

  async created() {
    this.messageInfo = await this.actionGetItem({
      id: this.$route.params.id,
      transport: this.transport,
    });
  }

  back(): void {
    this.$router.push(`/${this.transport.toLowerCase()}/detail_incoming/`);
  }

  get isShowFields(): boolean{
    return this.transport !== MsgTransports.WHATSAPP && this.transport !== MsgTransports.VIBER
  }
}
